// extracted by mini-css-extract-plugin
export default {"ConsentTextContainer":"ProceedToConsent_ConsentTextContainer__1RxMn","ConsentLink":"ProceedToConsent_ConsentLink__HQLTl"};